import { useCallback } from 'react';
export function useScrollTo() {
  const scrollTo = useCallback((targetId, onComplete) => {
    const cleanId = targetId.replace(/^\/?#?/, '');
    
    if (cleanId === 'accueil') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      if (onComplete) onComplete();
      return;
    }
    
    const element = document.getElementById(cleanId);
    
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      if (onComplete) onComplete();
    }
  }, []);

  return scrollTo;
}
